import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveModal from 'common/components/modules/responsive-modal';
import PosterImages from 'admin/views/stories/video-story-upload/poster-images';
import AccessSettings from 'admin/views/stories/share/access-settings';
import CommentPermissionModal from 'common/components/modules/comments-permission-modal';

function Stories({
   step,
   customPosterImage,
   onCloseModal,
   onPosterImageChange,
   statisticsData,
   onToggleFilter,
   storyType,
   hideStoryValue,
   description,
   filters,
   onVideoChange,
   videoInit,
   siteStatus,
   shareButtonText,
   sharePost,
   deleteImg,
   paths,
   onImageChange,
   onClickContinue,
   onChangeText,
   hideStory,
   headerTitle,
   height,
   isButtonDisable,
   onSortPhotosEnd,
   onChangePermission,
   isEdit,
   isShowHideAfter,
   commentPermission,
   isMobile,
   isDemoMode,
   storyIsSfw,
   videoStoryCustomThumbnailIsSfw,
   isCustomThumbnail,
}){
   function uploadStoryImgs(e) {
      if(onImageChange){
         onImageChange(e)
      }
   }
   let isDisabled = false;
   if(step !== 'access-setting') {
      if(storyType === 'image') {
         if(paths.length){
            paths.forEach(photo => {
               if(photo.loading){
                  isDisabled = true;
               }
            })
         } else isDisabled = true;
      } else {
         if(customPosterImage){
            if(customPosterImage.loading){
               isDisabled = true;
            }
         }
      }
   } else {
      isDisabled = isButtonDisable
   }
   let footerButtonText = 'Continue';
   if(step === 'access-setting' || isEdit) {
      footerButtonText = 'Done';
   } else if(isDisabled && step === 'edit-story') {
      footerButtonText = 'Uploading...';
   } else {
      footerButtonText = 'Continue'
   }
   return (
      <ResponsiveModal
         headerTitle={ headerTitle }
         headerLeftIconAction={ onCloseModal }
         onClose={ () => {} }
         width='516px'
         height={ height > 700 ? '680px' : `${ height }px` }
         footerButtonText={ footerButtonText }
         isDisabled={ isDisabled || (step === 'access-setting' && isDemoMode) }
         isLoading={ isButtonDisable }
         footerIconName={ step === 'access-setting' || isEdit ? '' : 'arrow-right' }
         footerIconPosition='left'
         foooterButtonAction={ onClickContinue }
         contentClass='px-0 pt-0 pb-4'
         dataToolTipContent={ step === 'access-setting' && isDemoMode ? 'Not available in demo' : '' }
      >
         <div
            style={ { minHeight: '430px' } }>
            {
               step === 'edit-story' && (
                  <>
                     <PosterImages
                        videoSrc={ customPosterImage.video_src }
                        onPosterImageChange={ onPosterImageChange }
                        customPosterImage={ customPosterImage }
                        type={ storyType }
                        description={ description }
                        onChangeText={ onChangeText }
                        paths={ paths }
                        uploadStoryImgs={ uploadStoryImgs }
                        deleteImg={ deleteImg }
                        onSortPhotosEnd={ onSortPhotosEnd }
                        storyIsSfw={ storyIsSfw }
                        videoStoryCustomThumbnailIsSfw={ videoStoryCustomThumbnailIsSfw }
                        isCustomThumbnail={ isCustomThumbnail }
                     />
                     {
                        isEdit && (
                           <div className='px-4 my-3 flex'>
                              <CommentPermissionModal
                                 permission={ commentPermission }
                                 onChangePermission={ onChangePermission }
                                 isMobile={ isMobile }

                              />
                           </div>
                        )
                     }
                  </>
               )
            }
            {
               step === 'access-setting' && (
                  <AccessSettings
                     statisticsData={ statisticsData }
                     onToggleFilter={ onToggleFilter }
                     type={ storyType }
                     hideStoryValue={ hideStoryValue }
                     description={ description }
                     hideStory={ hideStory }
                     onChangeText={ onChangeText }
                     sharePost={ sharePost }
                     deleteImg={ deleteImg }
                     onImageChange={ onImageChange }
                     filters={ filters }
                     path={ paths }
                     onVideoChange={ onVideoChange }
                     thumbnail={ videoInit.full_thumbnail }
                     videoSrc={ videoInit.video_src }
                     isHideAfterOptionVisible={ 'live' === siteStatus }
                     shareButtonText={ shareButtonText }
                     onChangePermission={ onChangePermission }
                     isShowHideAfter={ isShowHideAfter }
                     commentPermission={ commentPermission }
                     isMobile={ isMobile }
                  />
               )
            }
         </div>
      </ResponsiveModal>
   );
}
Stories.propTypes = {
   step: PropTypes.string,
   customPosterImage: PropTypes.object,
   onCloseModal: PropTypes.func,
   onPosterImageChange: PropTypes.func,
   statisticsData: PropTypes.object,
   onToggleFilter: PropTypes.func,
   storyType: PropTypes.string,
   hideStoryValue: PropTypes.bool,
   description: PropTypes.string,
   filters: PropTypes.array,
   onVideoChange: PropTypes.func,
   videoInit: PropTypes.object,
   siteStatus: PropTypes.string,
   shareButtonText: PropTypes.string,
   sharePost: PropTypes.func,
   deleteImg: PropTypes.func,
   paths: PropTypes.array,
   onImageChange: PropTypes.func,
   onClickContinue: PropTypes.func,
   onChangeText: PropTypes.func,
   hideStory: PropTypes.func,
   headerTitle: PropTypes.string,
   height: PropTypes.number,
   isButtonDisable: PropTypes.bool,
   onSortPhotosEnd: PropTypes.func,
   onChangePermission: PropTypes.func,
   commentPermission: PropTypes.string,
   isEdit: PropTypes.bool,
   isShowHideAfter: PropTypes.bool,
   isMobile: PropTypes.bool,
   isDemoMode: PropTypes.bool,
   storyIsSfw: PropTypes.bool,
   videoStoryCustomThumbnailIsSfw: PropTypes.bool,
   isCustomThumbnail: PropTypes.bool,
};
export default React.memo(Stories);
